import React from 'react';
import loadable from '@loadable/component';

const LightBox = loadable(() =>
  import(/* webpackChunkName: "extra" */ './lightbox')
);

const LoadableLightBox = props => <LightBox {...props} />;

export default LoadableLightBox;
